export class PlanAdoptionRoutes {
    public static readonly QccoQuestions: string = '/qcco-questions';

    public static readonly AdoptionDetails: string = '/adoption-details';

    public static readonly Review: string = '/review';

    public static readonly Indemnify: string = '/indemnify';
}